module.exports = __webpack_public_path__ + "static/media/portfolio5.c6e34db9.png";